// src/data/planning/planningRules.js

/**
 * REHBER360 - HEDEF ÇALIŞMALARI KURAL PROFİLLERİ
 *
 * Kaynak:
 * MEB Hedef İş Akışı Yönergesi (03.10.2023)
 *
 * Bu dosya:
 * - hangi kurumda hangi hedeflerin kullanılacağını,
 * - hedef başına minimum Düzey-1 faaliyet sayılarını,
 * - zorunlu / önerilen ayrımını
 * tanımlar.
 */

export const PLANNING_RULES_VERSION = "HEDEF-IS-AKISI-2023-V1";


// =========================================================
// KURAL PROFİLLERİ
// =========================================================

export const PLANNING_RULE_PROFILES = {

  // =======================================================
  // 1. NORMAL OKULLAR
  // Okul Öncesi / İlkokul / Ortaokul / Ortaöğretim
  // =======================================================

  regular_school: {

    id: "regular_school",

    label:
      "Okul Öncesi / İlkokul / Ortaokul / Ortaöğretim",

    applicableSchoolTypes: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    targets: {
      general: {
        enabled: true,
        required: true,
        count: 1
      },

      local: {
        enabled: true,
        required: true,
        count: 1
      },

      special: {
        enabled: true,
        required: true,
        count: 2
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 2,
        enforcement: "required"
      },

      parent: {
        count: 2,
        enforcement: "required"
      },

      teacher: {
        count: 1,
        enforcement: "recommended"
      }
    }
  },


  // =======================================================
  // 2. ÖZEL EĞİTİM OKULLARI
  // =======================================================

  special_education_school: {

    id: "special_education_school",

    label: "Özel Eğitim Okulları",

    applicableSchoolTypes: [
      "special_education"
    ],

    targets: {

      general: {
        enabled: false,
        required: false,
        count: 0
      },

      local: {
        enabled: false,
        required: false,
        count: 0
      },

      special: {
        enabled: true,
        required: true,
        count: 2,

        note:
          "Öğrenci faaliyetlerinin uygulanabilirliği okul türüne göre değerlendirilir."
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 1,
        enforcement: "conditional_required"
      },

      parent: {
        count: 1,
        enforcement: "required"
      },

      teacher: {
        count: 1,
        enforcement: "recommended"
      }
    }
  },


  // =======================================================
  // 3. BİLSEM
  // =======================================================

  bilsem: {

    id: "bilsem",

    label: "Bilim ve Sanat Merkezi",

    applicableSchoolTypes: [
      "bilsem"
    ],

    targets: {

      general: {
        enabled: false,
        required: false,
        count: 0
      },

      local: {
        enabled: false,
        required: false,
        count: 0
      },

      special: {
        enabled: true,
        required: true,
        count: 2
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 1,
        enforcement: "required"
      },

      parent: {
        count: 1,
        enforcement: "required"
      },

      teacher: {
        count: 1,
        enforcement: "recommended"
      }
    }
  },


  // =======================================================
  // 4. MESLEKİ EĞİTİM MERKEZİ (MESEM)
  // =======================================================

  mesem: {

    id: "mesem",

    label: "Mesleki Eğitim Merkezi",

    applicableSchoolTypes: [
      "mesem"
    ],

    targets: {

      general: {
        enabled: false,
        required: false,
        count: 0
      },

      local: {
        enabled: false,
        required: false,
        count: 0
      },

      special: {
        enabled: true,
        required: true,
        count: 2
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 1,
        enforcement: "required"
      },

      parent: {
        count: 1,
        enforcement: "required"
      },

      teacher: {
        count: 1,
        enforcement: "recommended"
      }
    }
  },


  // =======================================================
  // 5. HALK EĞİTİM MERKEZİ
  // =======================================================

  public_education_center: {

    id: "public_education_center",

    label: "Halk Eğitim Merkezi",

    applicableSchoolTypes: [
      "public_education_center"
    ],

    targets: {

      general: {
        enabled: false,
        required: false,
        count: 0
      },

      local: {
        enabled: false,
        required: false,
        count: 0
      },

      special: {
        enabled: true,
        required: true,
        count: 2
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 1,
        enforcement: "required",
        audienceLabel: "Öğrenci / Kursiyer"
      },

      parent: {
        count: 0,
        enforcement: "not_required"
      },

      teacher: {
        count: 0,
        enforcement: "not_required"
      }
    }
  },


  // =======================================================
  // 6. KADROSU BİR OKULDA OLUP BAŞKA OKULA DA
  // GÖREVLENDİRİLEN REHBER ÖĞRETMEN
  // Görevlendirildiği okul için kullanılacak profil
  // =======================================================

  assigned_additional_school: {

    id: "assigned_additional_school",

    label:
      "Başka Okulda Görevlendirilen Rehber Öğretmen / Psikolojik Danışman",

    applicableSchoolTypes: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    targets: {

      general: {
        enabled: true,
        required: true,
        count: 1
      },

      local: {
        enabled: true,
        required: true,
        count: 1
      },

      special: {
        enabled: true,
        required: true,
        count: 2
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 1,
        enforcement: "required"
      },

      parent: {
        count: 1,
        enforcement: "required"
      },

      teacher: {
        count: 1,
        enforcement: "recommended"
      }
    }
  },


  // =======================================================
  // 7. REHBER ÖĞRETMEN / PSİKOLOJİK DANIŞMAN
  // BULUNMAYAN OKULLAR
  // =======================================================

  no_counselor_school: {

    id: "no_counselor_school",

    label:
      "Rehber Öğretmen / Psikolojik Danışmanı Bulunmayan Okul",

    targets: {

      general: {
        enabled: true,
        required: true,
        count: 1
      },

      local: {
        enabled: true,
        required: true,
        count: 1
      },

      special: {
        enabled: false,
        required: false,
        count: 0
      }
    },

    minimumLevel1PerTarget: {

      student: {
        count: 2,
        enforcement: "required"
      },

      parent: {
        count: 1,
        enforcement: "required"
      },

      teacher: {
        count: 1,
        enforcement: "recommended"
      }
    },

    notes: [
      "Genel ve yerel hedef çalışmalarının RAM iş birliğiyle yürütülmesi gerekir.",
      "Bu kurumlar özel hedef belirlemez."
    ]
  }

};


// =========================================================
// FAALİYET DÜZEYLERİ
// =========================================================

export const ACTIVITY_LEVEL_RULES = {

  level1: {
    id: 1,

    label: "Düzey 1",

    description:
      "Büyük grup ve sınıf rehberliği kapsamında yürütülen faaliyetler."
  },

  level2: {
    id: 2,

    label: "Düzey 2",

    description:
      "Ardışık büyük grup ve sınıf rehberliği çalışmaları ile küçük grup çalışmaları.",

    required: false
  },

  level3: {
    id: 3,

    label: "Düzey 3",

    description:
      "Küçük grup çalışmaları ile psikoeğitim programı hazırlama ve uygulama.",

    required: false
  }

};


// =========================================================
// DÜZEY 2 / 3 KAPSAMA KURALI
// =========================================================

export const COVERAGE_RULES = {

  /**
   * Düzey 2 veya 3 faaliyet hedef kitlenin yalnızca
   * bir bölümüne uygulanmışsa, ulaşılmayan kişiler için
   * ilgili profilin Düzey-1 minimumları devam eder.
   */

  partialCoverageRequiresLevel1: true,

  coverageValues: [
    "all",
    "partial"
  ]
};


// =========================================================
// YARDIMCI FONKSİYONLAR
// =========================================================

export const getPlanningRuleProfile = (profileId) => {
  return PLANNING_RULE_PROFILES[profileId] || null;
};


export const getRuleProfileForSchoolType = (schoolType) => {

  const profiles = Object.values(
    PLANNING_RULE_PROFILES
  );

  return (
    profiles.find(profile =>
      profile.applicableSchoolTypes?.includes(schoolType)
    ) || null
  );
};


export const getRequiredTargetCount = (profileId) => {

  const profile = getPlanningRuleProfile(profileId);

  if (!profile) return 0;

  const generalCount =
    profile.targets.general?.enabled
      ? profile.targets.general.count
      : 0;

  const localCount =
    profile.targets.local?.enabled
      ? profile.targets.local.count
      : 0;

  const specialCount =
    profile.targets.special?.enabled
      ? profile.targets.special.count
      : 0;

  return generalCount + localCount + specialCount;
};


export const getMinimumLevel1ForAudience = (
  profileId,
  audience
) => {

  const profile = getPlanningRuleProfile(profileId);

  if (!profile) return null;

  return (
    profile.minimumLevel1PerTarget?.[audience] ||
    null
  );
};